var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "select" }, [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.id,
            expression: "id",
          },
        ],
        on: {
          change: function ($event) {
            var $$selectedVal = Array.prototype.filter
              .call($event.target.options, function (o) {
                return o.selected
              })
              .map(function (o) {
                var val = "_value" in o ? o._value : o.value
                return val
              })
            _vm.id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          },
        },
      },
      [
        _c("option", { domProps: { value: 0 } }, [_vm._v("-")]),
        _vm._l(_vm.healthservices, function (option) {
          return _c("option", {
            key: option.id,
            domProps: { value: option.id, textContent: _vm._s(option.name) },
          })
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }